<template lang="pug">
page(
    main-title="Скидки, наценки, изменение сроков"
)
    template(slot="description") Просмотр 
        span.text-bold правил
        |, влияющих на стоимость и срок доставки
    .panel
        .panel-heading 
            button.btn.btn-wide.btn-default(@click="edit({})") Добавить
        .panel-body
            template(v-for='rule in costRules')
                p(:style="{textDecoration: (rule.active ? 'none' : 'line-through')}")
                    a(@click="edit(rule)") \#{{ rule.priority }} {{ rule.description_short }} 
                    | {{ rule.description_long + ' ' }}

</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'CostRules',
    created() {
        this.getDataHook();
    },
    computed: {
        ...mapGetters(['costRules', 'deliveryPaymentTypes'])
    },
    methods: {
        getDataHook() {
            this.$store.dispatch('loadCostRules');
            this.$store.dispatch('loadDeliveryPaymentTypes');
        },
        edit(rule) {
            this.$store.commit('changeEditedCostRule', rule);

            this.$router.push({name: 'EditCostRule'});
        }
    }
};
</script>


// WEBPACK FOOTER //
// src/components/costRules/CostRules.vue